// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthProvider from './components/AuthProvider';
import MainApp from './components/MainApp';
import NotFoundPage from './components/NotFoundPage';
import LogoutPage from './components/LogoutPage';
import 'semantic-ui-css/semantic.min.css';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="/" element={<MainApp />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;